import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { colors, rgbColors, animation } from '../styles/constants';

const { shortAnimationDuration, transitionTimingFn } = animation;

const getBackgroundColor = (type, hover = false) => {
  switch (type) {
    case 'secondary':
      return rgbColors[`cyan${hover ? 'Hover' : ''}`];
    case 'dark':
      return 'transparent';
    case 'primary':
    default:
      return rgbColors[`white${hover ? 'Hover' : ''}`];
  }
};

const getColor = type => {
  switch (type) {
    case 'secondary':
      return colors.white;
    case 'dark':
      return colors.white;
    case 'primary':
    default:
      return colors.cyan;
  }
};

const Button = styled.button`
  padding: 1rem 1.7rem;
  border-radius: 0.5rem;
  border: none;
  font-weight: 600;
  font-size: 2.2rem;
  opacity: 1;
  background-color: ${props => getBackgroundColor(props.type)};
  color: ${props => getColor(props.type)};

  transition: opacity, color,
    background-color ${shortAnimationDuration}ms ${transitionTimingFn};

  > * {
    color: ${props => getColor(props.type)};
    font-weight: 600;
  }

  ${props =>
    props.type !== 'dark' &&
    css`
      min-width: 15rem;
    `}

  &:active,
  &:hover,
  &:focus,
  &.active {
    cursor: pointer;
    opacity: 0.9;
    color: ${props => getColor(props.type)};
    background-color: ${props => getBackgroundColor(props.type, true)};

    > * {
      opacity: 0.9;
      color: ${props => getColor(props.type)};
    }

    ${props =>
      props.type === 'dark' &&
      css`
        background-color: ${rgbColors.blueHover};
      `}
  }

  &:focus {
    outline: 0;
  }
`;

Button.defaultProps = {
  type: 'primary'
};

Button.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary', 'dark'])
};

export default Button;
